import { Link } from 'react-router-dom';
import allImgPaths from "../../../assets/images";
import ImageLoader from 'components/loaders/ImageLoader';
import { cloneDeep } from 'lodash';
import React, { useState } from 'react';
import VendorDetailsModal from 'components/common/modal/VendorDetailsModal';

function ImageCard({ data, index, updateMessage: updateMessage }: any) {
	const [showDetailsModal, setShowDetailsModal] = useState(false);

	const handleChange = async (name: any, isChecked: boolean) => {
		data['selected'] = isChecked;
		data['selectedTags'] = isChecked ? cloneDeep(data?.tags || []) : []

		handleDataUpdate()
	}

	const selectTag = (tag: any) => {
		const selectedTags = data?.selectedTags || [];
		const index = selectedTags.indexOf(tag);
		if (index != -1) selectedTags.splice(index, 1)
		else selectedTags.push(tag)

		data['selectedTags'] = selectedTags
		data['selected'] = selectedTags?.length ? true : false;

		handleDataUpdate()
	}

	const handleDataUpdate = () => {
		const newData = { ...data };
		updateMessage(index, newData, 'selectedTags')
		updateMessage(index, newData, 'selected')
	}

	const clickFilter = (text?: string) => {
		if (text) {
			console.log('On View Detail')
		} else {
			console.log('On Add Tags')
			addTag()
		}
	}

	const addTag = (text?: string) => {
		// if (text) return;
		const tags = data?.tags || [];
		if (tags.includes('')) return
		tags.push('')
		data['tags'] = tags;

		handleDataUpdate()
	}

	const updateTag = (value: any, tagIndex: any) => {
		const tags = data?.tags || [];
		const selectedTags = data?.selectedTags || []
		if (value) {
			tags[tagIndex] = value
			selectedTags.push(value)
		}
		data['tags'] = tags
		data['selectedTags'] = selectedTags
		data['selected'] = selectedTags?.length ? true : false;
		handleDataUpdate()
	}

	const setFavorite = (value: boolean) => {
		data['is_favorite'] = value;
		const newData = { ...data };
		updateMessage(index, newData, 'is_favorite')
	}

	const handleImageError = (e: any) => {
		e.target.src = allImgPaths.noImage
	}

	const openDetailsModal = (title: any) => {
		setShowDetailsModal(true)
	}

	return (
		<>
			{
				showDetailsModal &&
				<VendorDetailsModal
					data={{ title: data?.title, venueId: data?.venueId }}
					setShowDetailsModal={setShowDetailsModal}
				/>
			}
			<div className="border border-[#EAECF0] rounded-[10px] w-[254px] bg-white mb-2" style={{ display: data?.isHidden ? 'none' : 'block' }}>
				<div className="px-2 py-2 relative w-[252px] h-[240px] rounded-[10px]">
					{!data?.imageUrl && (
						<ImageLoader />
					)}
					{data?.imageUrl && (
						<img className="rounded-[10px] object-cover w-full h-full" onError={handleImageError} src={data?.imageUrl} alt="" />
					)}

					{
						<>
							{data?.showCheckBox == false
								? ''
								:
								<span className="absolute top-4 left-4">
									<span className='checkbox-alignment'>
										<input
											type='checkbox'
											name={data.title}
											checked={data?.selected || false}
											onChange={(e) => handleChange(e.target.name, e.target.checked)}
											style={{ width: '18px', height: '18px', cursor: 'pointer' }}
										/>
									</span>
								</span>
							}
							<img onClick={() => setFavorite(!data?.is_favorite)} className="absolute top-4 right-4 w-6 h-6 cursor-pointer" src={data?.is_favorite ? allImgPaths.heartIconRed : allImgPaths.heartIconWhite} alt="" />
						</>
					}
				</div>
				<div className="px-3 pb-3">
					{data?.matchFor && (
						<span className="text-xs font-interMedium text-[#667085]">Match For:</span>
					)}
					<h5 title={data?.title} className="text-lg text-[#101828] font-interSemiBold leading-[1.4] mb-2 line-clamp-2 max-w-96 h-[50px]">{data?.title}</h5>
					{/* SELECTED TAGS BELOW */}
					{/* <div className="flex flex-wrap gap-1.5">
						<span className="text-xs font-interMedium text-[#1E0AF5] py-0.5 px-1.5 rounded border border-[#D2CEFD] bg-[#E8E6FE]">Upscale</span>
						<span className="text-xs font-interMedium text-[#1E0AF5] py-0.5 px-1.5 rounded border border-[#D2CEFD] bg-[#E8E6FE]">Artsy</span>
					</div> */}
					{/* <div className="w-full h-px bg-[#EAECF0] my-2"></div> */}
					{!data.hasOwnProperty('type') && data?.type != 'crawled' &&
						<div className="flex flex-wrap gap-1.5 min-h-[50px] items-start">
							{data?.tags && data?.tags.length > 0 && data?.tags.map((tag: any, tagIndex: number) => (
								<React.Fragment key={tagIndex}>
									{
										tag
											? <span key={tagIndex}
												className={`text-xs font-interMedium text-[#363F72] py-0.5 px-1.5 rounded border border-[#D5D9EB] bg-[#F8F9FC] pointer-cursor ${(data?.selectedTags || []).includes(tag) ? '!bg-[#E8E6FE] !text-[#1E0AF5] !border-[#D2CEFD] !font-interMedium' : ''}`}
												onClick={() => selectTag(tag)}>{tag}</span>
											: <div className="flex items-center border border-[#D5D9EB] rounded-md">
												<input type="text"
													className={`w-28 px-2 py-px text-sm rounded-md`}
													name={"tag"}
													placeholder="Enter here"
													onBlur={(e) => updateTag(e.target.value, tagIndex)} />
												<img className="w-[16px] mr-1 cursor-pointer" src={allImgPaths.rightCheckMarkIcon} alt="" />
											</div>
									}

								</ React.Fragment>
							))}
						</div>}
					{data?.description && (
						<p className='text-[#373738] text-sm font-interMedium'>{data?.description}</p>
					)}
					<div className="pt-0.5">
						{
							data.hasOwnProperty('type') && data?.type == 'crawled' &&
							<Link to="#" onClick={() => openDetailsModal(data?.title)} className="text-[#1E0AF5] hover:text-[#0C0462] text-sm font-interSemiBold inline-block">
								View Details
							</Link>
						}
						{
							!data.hasOwnProperty('type') && data?.type != 'crawled' &&
							<Link onClick={() => clickFilter(data?.description)} to="#" className="text-[#1E0AF5] hover:text-[#0C0462] text-sm font-interSemiBold inline-block">
								Add More
							</Link>
						}
						{/* <Link onClick={() => clickFilter(data?.description)} to="#" className="text-[#1E0AF5] text-sm font-interSemiBold inline-block">
						{data.hasOwnProperty('type') && data?.type == 'crawled' ? 'View Details' : 'Add More'}
					</Link> */}
					</div>
				</div>
			</div>
		</>
	)
}

export default ImageCard
